import { DefaultOptionInfo } from "../../model/RepairShop/DefaultOption";
import { axiosUtils } from "../../network/axiosUtils";
import httpRequest from "../../network/httpRequest";

const URL = "/repair-shop";

/**
 * 매장 기본옵션정보
 * @returns
 */
export const getDefaultOptions = async (): Promise<
  Array<DefaultOptionInfo>
> => {
  const url = `${URL}/default-option`;

  const response = await httpRequest({
    method: axiosUtils.GET,
    url,
  });

  return response?.data.rows;
};
